export default __webpack_public_path__ + "static/media/dialogflow.3bc9fa96.svg";